// max width if some item don't fit
export const MAX_SHORT_TOKEN_WIDTH = 80;
export const MIN_LONG_TOKEN_WIDTH = 50;
export const TOKEN_MARGIN_RIGHT = 5;